import {
  Award,
  BarChart3,
  BookOpen,
  Building2,
  Calendar,
  CalendarCheck,
  Check,
  FileText,
  Megaphone,
  Flame,
  Gavel,
  Gift,
  GraduationCap,
  Heart,
  Landmark,
  LayoutGrid,
  LucideIcon,
  Monitor,
  MoreHorizontal,
  Scale,
  Shield,
  ShieldCheck,
  Star,
  Trophy,
  Users,
} from "lucide-react";
import { IconKey } from "../types";

export const PLAN_ICONS: Record<IconKey, LucideIcon> = {
  grid: LayoutGrid,
  landmark: Landmark,
  shield: Shield,
  "shield-check": ShieldCheck,
  "book-open": BookOpen,
  scale: Scale,
  heart: Heart,
  users: Users,
  monitor: Monitor,
  more: MoreHorizontal,
  check: Check,
  "bar-chart": BarChart3,
  trophy: Trophy,
  star: Star,
  calendar: Calendar,
  "graduation-cap": GraduationCap,
  gift: Gift,
  building: Building2,
  gavel: Gavel,
  flame: Flame,
  award: Award,
  megaphone: Megaphone,
  "file-text": FileText,
  "calendar-check": CalendarCheck,
};
